import api from './api';

export const frontendMenuService = {
    // Get public menus (no auth required)
    getPublicMenus: async () => {
        try {
            const response = await api.get('/frontend-menus/public');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil menu'
            };
        }
    },

    // Get all menus (admin)
    getMenus: async (params = {}) => {
        try {
            const response = await api.get('/frontend-menus', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil menu'
            };
        }
    },

    // Create menu
    /*createMenu: async (menuData) => {
        try {
            const response = await api.post('/frontend-menus', menuData);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal membuat menu'
            };
        }
    },*/
    createMenu: async (data) => {
        try {
            const isFormData = data instanceof FormData;
            const response = await api.post('/frontend-menus', data, {
                headers: isFormData
                    ? { 'Content-Type': 'multipart/form-data' }
                    : { 'Content-Type': 'application/json' }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal membuat menu' };
        }
    },

    // Update menu
    /*updateMenu: async (id, menuData) => {
        try {
            const response = await api.put(`/frontend-menus/${id}`, menuData);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate menu'
            };
        }
    },*/
    updateMenu: async (id, data) => {
        try {
            const isFormData = data instanceof FormData;
            const response = await api.post(`/frontend-menus/${id}`, data, {
                headers: isFormData
                    ? { 'Content-Type': 'multipart/form-data' }
                    : { 'Content-Type': 'application/json' }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal mengupdate menu' };
        }
    },

    // Delete menu
    deleteMenu: async (id) => {
        try {
            const response = await api.delete(`/frontend-menus/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menghapus menu'
            };
        }
    },

    // Reorder menus
    reorderMenus: async (menus) => {
        try {
            const response = await api.post('/frontend-menus/reorder', { menus });
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengurutkan menu'
            };
        }
    },

    // Toggle active
    toggleActive: async (id) => {
        try {
            const response = await api.post(`/frontend-menus/${id}/toggle-active`);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengubah status'
            };
        }
    },

    getMenuBySlug: async (slug) => {
        try {
            const response = await api.get(`/frontend-menus/by-slug/${slug}`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data menu'
            };
        }
    }
};